export default "__VITE_ASSET__CG0Wmzfa__"